// 📁 src/pages/LoginPage.js
import React, { useState, useContext } from "react";
import axios from "../context/AxiosInstance";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../styles/login.css"; // fichier CSS

const LoginPage = () => {
  const [login, setLogin] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [erreur, setErreur] = useState("");
  const navigate = useNavigate();
  const { login: loginContext } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur("");
    setIsLoading(true);

    try {
      const response = await axios.post("/auth/login", {
        login: login,
        mot_de_passe: motDePasse,
      });

      const data = response?.data || {};
      // Compat: différents contrats de réponse possibles
      const token = data.access_token || data.token;
      const user = data.user || data.data?.user;
      const role = ((user?.type_compte) || "").toUpperCase();

      if (token && user) {
        const ok = loginContext(token, role, user);
        if (ok) {
          if (role === "ADMIN") navigate("/personnel-admin"); else navigate("/employes");
          return;
        }
        setErreur("Erreur lors de la connexion. Veuillez réessayer.");
      } else if (data.success === false) {
        setErreur(data.message || "Échec de connexion.");
      } else {
        setErreur("Identifiants invalides.");
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      const resp = error.response?.data;
      if (resp?.detail) {
        const d = resp.detail;
        const msg = typeof d === "string" ? d : (d?.message || d?.detail || JSON.stringify(d));
        setErreur(msg);
      } else if (error.code === "NETWORK_ERROR" || error.code === "ERR_NETWORK") {
        setErreur("Erreur de connexion au serveur. Vérifiez votre connexion internet.");
      } else {
        setErreur("Login ou mot de passe incorrect.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    const { value: loginVal } = await Swal.fire({
      title: "Mot de passe oublié",
      input: "text",
      inputLabel: "Entrez votre login",
      inputPlaceholder: "Votre login",
      inputValue: login || "",
      showCancelButton: true,
      confirmButtonText: "Envoyer la demande",
      cancelButtonText: "Annuler",
      inputValidator: (v) => (!v ? "Veuillez saisir votre login" : undefined),
    });
    if (!loginVal) return;
    try {
      const res = await axios.post("/utilisateurs/mot-de-passe-oublie", { login: loginVal });
      Swal.fire(
        "Demande envoyée ✅",
        res.data?.message || "Votre demande a été transmise à l'administrateur. Il vous communiquera un nouveau mot de passe.",
        "success"
      );
    } catch {
      Swal.fire(
        "Demande envoyée",
        "Si ce compte existe, l'administrateur a été notifié et vous communiquera un nouveau mot de passe.",
        "info"
      );
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form shadow">
        <h3>Connexion</h3>
        {erreur && <div className="alert alert-danger">{erreur}</div>}
        <input type="text" placeholder="Login" value={login} onChange={(e) => setLogin(e.target.value)} className="form-control mb-3" required disabled={isLoading} />
        <input type="password" placeholder="Mot de passe" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} className="form-control mb-3" required disabled={isLoading} />
        <button className="btn btn-primary w-100" disabled={isLoading}>
          {isLoading ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Connexion en cours...</>) : ("Se connecter")}
        </button>
        <div className="text-center mt-3">
          <button type="button" className="btn btn-link p-0" onClick={handleForgotPassword} disabled={isLoading}>
            Mot de passe oublié ?
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
